/**
 * 前端可控错误或异常状态文本
 * [注] 接口异常状态文本，由后端自主管理，不代管
 *
 * @enum
 *
 * @readonly
 */
const HTTP_CODE_MESSAGE = {
  // 网络相关，请求[400, 404, 500, 502, 503, 504]等
  NETWORK_1001: '接口异常，请尝试刷新或稍后再试',
  // 网络相关
  NETWORK_500: '网络不佳，请稍后重试',

  // 接口请求相关
  405: '请求错误',
  404: '接口地址错误',
  403: '拒绝访问接口',

  REQUEST_1002: '请求超时，请稍后重试',
  REQUEST_1003: '这里会抛出服务端给的自定义错误', // 接口请求成功，但属于errorStatusList中的一项时

  // 未知错误
  UNKNOW_1001: '未知错误',
}

export default HTTP_CODE_MESSAGE
